<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('diarios')">Edit Item:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.contact}}
    </h1>
    <trashed-message v-if="diariosdetalles.deleted_at" class="mb-6" @restore="restore">
     El Comercial fue Eliminado!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
         <p>Description:</p>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
         
           <textarea v-model="form.descripcion" :error="form.errors.descripcion" class="border-solid border-2 border-sky-500 pr-6 pb-8 w-3/6"/>
                    <text-input v-model.number="form.id_reporte" :error="form.errors.last_name" class="invisible pr-6 pb-8 w-1/6" label="Número Reporte" />

          <text-input v-model="form.valor" :error="form.errors.valor" class="pr-6 pb-8 w-2/6" label="Amount" />
                    
         
                   </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
     <button v-if="!diariosdetalles.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Deleted Item</button>
       <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Item</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: 'Update Item',
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
   diariosdetalles: Object,
   contacts: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
          id_reporte: this.diariosdetalles.reporte_diario_id,
      descripcion: this.diariosdetalles.descripcion,
        valor: this.diariosdetalles.valor,
        
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('diariosdetalles.update', this.diariosdetalles.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('diariosdetalles.destroy', this.diariosdetalles.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('diariosdetalles.restore', this.diariosdetalles.id))
      }
    },
  },
}
</script>
